import {animated} from 'react-spring';

import styled, {css} from 'styled-components';

import {mixins} from '../styles';

export const NotificationCount = styled.div`
  position: relative;
  ${mixins.wh('20px')}
  ${mixins.flexAlign('center')}
`;

type TCountProps = {
  hasBackground?: boolean;
};

// TODO: add to color palette
const brightPurple = '#bc1bc6';

export const Count = styled.div<TCountProps>`
  ${mixins.f1}
  font-weight: 600;
  ${mixins.position({position: 'absolute', top: '50%', left: '50%'})}
  transform: translate(-50%, -50%);
  ${({hasBackground, theme}) =>
    hasBackground &&
    css`
      background-color: ${brightPurple};
      padding: 0 ${theme.spacing.s1};
      border-radius: ${theme.borderRadius.br3};
    `}
`;

export const EllipsisWrapper = styled(animated.div)`
  display: flex;
  ${mixins.wh('22px')}
  ${({theme: {zIndex}}) => css`
    z-index: ${zIndex.background};
    color: ${brightPurple};
  `}
`;
